import * as React from 'react';
import { forwardRef, ComponentPropsWithoutRef } from 'react';
import clsx from 'clsx';

export enum InputSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
}

type GIInputPropsPicked =
  'id'
  | 'autoComplete'
  | 'defaultValue'
  | 'inputMode'
  | 'maxLength'
  | 'name'
  | 'onBlur'
  | 'onChange'
  | 'onFocus'
  | 'placeholder'
  | 'required'
  | 'role'
  | 'type'
  | 'onKeyDown'
  | 'value';
export interface IGIInputProps extends Pick<ComponentPropsWithoutRef<'input'>, GIInputPropsPicked> {
  size?: InputSize;
}

export const GIInput = forwardRef<HTMLInputElement, IGIInputProps>(function GIInput({
  id,
  inputMode,
  size = InputSize.MD,
  maxLength,
  name,
  onBlur,
  onChange,
  onFocus,
  onKeyDown,
  placeholder,
  required = false,
  type,
  value,
}, ref) {

  const inputClassNames = clsx(
    'gi-input',
    {
      'gi-input-xs': size === InputSize.XS,
      'gi-input-sm': size === InputSize.SM,
      'gi-input-md': size === InputSize.MD,
      'gi-input-lg': size === InputSize.LG,
    }
  );

  return (
    <input
      data-testid={id}
      id={id}
      name={name}
      ref={ref}
      type={type}
      value={value}
      className={inputClassNames}
      placeholder={placeholder}
      aria-label={placeholder}
      aria-required={required}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      maxLength={maxLength}
      inputMode={inputMode}
    />
  );
});
